import BusinessImpactComment from "../BusinessImpactComment";
import SidebarModal from "../sidebar-modal";
import "./index.css";
import { IoClose } from "react-icons/io5";
import moment from "moment";
import { GridLoaderComponent } from "../loaders";

const BusinessImapactSideBar = (props) => {
  const {
    onClose,
    companyName = "",
    data = [],
    handleDeleteReplyClick,
    onSave,
    loader = false,
    accessActionAddReply,
    loggedInUserId,
    isSaveDisabled,
    setIsSaveDisabled,
  } = props;
  return (
    <SidebarModal
      style={{ minWidth: "375px", postion: "fixed", width: "25%", marginTop: "62px", position: "fixed" }}
      backDrop={true}
      childrenClassName="business-impact-sidebar-wrapper"
      className="business-impact-sidebar"
    >
      {loader ? (
        <GridLoaderComponent size={15} />
      ) : (
        <>
          <div className="business-impact-header">
            <div className="business-impact-comment">
              <span className="comment-heading">Comments - Business Impact Assessment</span>
              <div className="company-name-heading mt-1 mb-1">
                Company: <span className="ml-1">{companyName || "-"}</span>
              </div>
            </div>
            <IoClose onClick={onClose} className="business-impact-close-icon" size={31} />
          </div>

          <div className="comment-section">
            <div className="comment-heading-top">Do you perceive this company as an Opportunity or a Threat?</div>
            <div className="comments-box">
              {data?.length > 0 &&
                data.map((comment) => {
                  return (
                    <BusinessImpactComment
                      userName={comment?.commentCreatedByUserFname + " " + comment?.commentCreatedByUserLname}
                      date={moment(comment?.commentCreatedDate).format("DD MMM YYYY")}
                      rating={comment?.commentRating}
                      commentText={comment?.commentText || ""}
                      replies={comment?.replies || []}
                      handleDeleteReplyClick={handleDeleteReplyClick}
                      onSaveCommentClick={onSave}
                      id={comment?.id}
                      accessActionAddReply={accessActionAddReply}
                      loggedInUserId={loggedInUserId}
                      isSaveDisabled={isSaveDisabled}
                      setIsSaveDisabled={setIsSaveDisabled}
                    />
                  );
                })}
            </div>
          </div>
        </>
      )}
    </SidebarModal>
  );
};

export default BusinessImapactSideBar;
